import React from "react";
import {SVGImage} from "../../../../../core/components/image/svg-image";
import classNames from "classnames";
import styles from "../styles/footer.module.scss";
import type {FooterModuleCountryComplianceModel} from "../models/footer-module.country-compliance.model";

export const FooterModuleCountryCompliance = ({controller}) => {
  const {countryCompliance} = controller.state;

  if (!(countryCompliance?.length > 0)) {
    return null;
  }

  return <div className={classNames(styles.country_compliance)}>
    {
      countryCompliance?.map((legal: FooterModuleCountryComplianceModel) => {

        return <a href={legal.url} rel="nofollow, noreferrer" target="_blank" className={classNames(styles.item)}>
          <SVGImage src={legal.image} style={{height: legal?.imageHeight}}/>
        </a>
      })
    }
  </div>
}